module.exports = __webpack_public_path__ + "new_collection_icon.a323b804fdac4f2bd998477db11b3f0f.svg";